import { render, staticRenderFns } from "./DriversForm.vue?vue&type=template&id=4efd9838&scoped=true&"
import script from "./DriversForm.vue?vue&type=script&lang=js&"
export * from "./DriversForm.vue?vue&type=script&lang=js&"
import style0 from "./DriversForm.vue?vue&type=style&index=0&id=4efd9838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efd9838",
  null
  
)

export default component.exports